import Layout from '../components/Layout';

const MEMBERSHIP_FORM_URL =
  'https://docs.google.com/forms/d/e/1FAIpQLScB_wBC_P8LivyBE_rox_LlzB51e3Ym2yeu2GAR71s9HMWyEw/viewform?usp=dialog';

export default function Memberships() {
  return (
    <Layout>
      <div className="container mx-auto px-4 py-10">
        <h1 className="text-2xl sm:text-3xl font-semibold tracking-tight">Memberships</h1>
        <p className="text-sm sm:text-base text-gray-400 mt-1">
          Student membership pricing.
        </p>

        <div className="grid gap-4 sm:gap-6 grid-cols-1 sm:grid-cols-2 mt-6">
          <div className="rounded-2xl p-5 border border-white/5 bg-zinc-900/40 shadow-[0_1px_0_rgba(255,255,255,0.04)]">
            <div className="text-lg font-semibold">Student Membership</div>
            <ul className="mt-3 text-sm text-gray-300 space-y-2">
              <li><span className="font-semibold">$699</span> paid upfront (4 months)</li>
              <li><span className="font-semibold">$199</span> per month</li>
            </ul>

            <a
              href={MEMBERSHIP_FORM_URL}
              target="_blank"
              rel="noreferrer"
              className="mt-5 inline-block rounded-full px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white font-semibold"
            >
              Join now
            </a>
          </div>
        </div>
      </div>
    </Layout>
  );
}
